// GENERADO por scripts/optimize-loading-bgs.mjs — NO editar a mano.
// Re-generar con: npm run optimize:loading
export const LOADING_IMAGES = [
  "/loading/carga-1.webp",
  "/loading/carga-2.webp",
  "/loading/carga-3.webp",
  "/loading/carga-4.webp"
];
